exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_box[data-v-48788cd5]{padding:10px 10px 16px}.auth_box[data-v-48788cd5]{padding:0 10px 16px}.auth_box .link[data-v-48788cd5]{margin-left:10px}.base_info .info_list[data-v-48788cd5]{padding:20px 0}.base_info .info_list .tips[data-v-48788cd5]{display:inline-table;padding-left:20px;font-style:italic;color:#666;font-size:12px}\n", ""]);

// exports
